import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

// An countdown timer implementation
var CountdownTimer = /*#__PURE__*/function () {
  function CountdownTimer(duration, onEndCallback) {
    _classCallCheck(this, CountdownTimer);

    _defineProperty(this, "duration", void 0);

    _defineProperty(this, "onExpire", void 0);

    _defineProperty(this, "timerID", void 0);

    this.duration = duration;
    this.onExpire = onEndCallback;
  }

  _createClass(CountdownTimer, [{
    key: "start",
    value: function start() {
      var _this = this;

      if (this.timerID) {
        clearTimeout(this.timerID);
      }

      this.timerID = setTimeout(function () {
        _this.onExpire();
      }, this.duration);
    }
  }, {
    key: "restart",
    value: function restart() {
      this.start();
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.timerID) {
        clearTimeout(this.timerID);
      }
    }
  }]);

  return CountdownTimer;
}();

export { CountdownTimer as default };